const CONFIG = {
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
    REQUEST_TIMEOUT: process.env.REACT_APP_REQUEST_MAX_TIMEOUT,
    BITESHIP_API_ENDPOINT: process.env.REACT_APP_BITESHIP_API_ENDPOINT,
    GOOGLE_RECAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
}

export default CONFIG
